import API from "../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalizeClientDetailCategory } from "../../utils/clientDetailsCategory";

const getClientTaxStrategies = createAsyncThunk(
  "taxStrategy/getClientTaxStrategiesStatus",
  async (arg) => {
    const clientId = typeof arg === "object" ? arg?.clientId : arg;
    const category =
      typeof arg === "object" ? arg?.category : undefined;
    if (!clientId) return [];

    try {
      const qs = category
        ? `?category=${encodeURIComponent(normalizeClientDetailCategory(category))}`
        : "";
      const { data } = await API.get(
        `client/getClientTaxStrategies/${clientId}${qs}`,
      );
      return data?.data || [];
    } catch (error) {
      console.log(error);
      return [];
    }
  },
);

const PDF_REQUEST_TIMEOUT_MS = 180000;

const createClientTaxStrategy = async ({
  client_id,
  strategy,
  plan_name,
  category,
}) => {
  try {
    const data = await API.post(
      `client/createClientTaxStrategy`,
      {
        client_id,
        strategy,
        plan_name,
        ...(category ? { category } : {}),
      },
      { timeout: PDF_REQUEST_TIMEOUT_MS },
    );
    return data;
  } catch (error) {
    console.log(error);
    return error?.response || { data: { status: 0, message: error.message } };
  }
};

const updateClientTaxStrategy = async ({ strategy_id, strategy, plan_name }) => {
  try {
    const data = await API.put(
      `client/updateClientTaxStrategy/${strategy_id}`,
      { strategy, plan_name },
      { timeout: PDF_REQUEST_TIMEOUT_MS },
    );
    return data;
  } catch (error) {
    console.log(error);
    return error?.response || { data: { status: 0, message: error.message } };
  }
};

const saveClientTaxStrategy = async (strategyId) => {
  try {
    const data = await API.post(`client/saveClientTaxStrategy/${strategyId}`);
    return data;
  } catch (error) {
    console.log(error);
    return error?.response || { data: { status: 0, message: error.message } };
  }
};

const sendClientTaxStrategy = async (strategyId) => {
  try {
    const data = await API.post(`client/sendClientTaxStrategy/${strategyId}`);
    return data;
  } catch (error) {
    console.log(error);
    return error?.response || { data: { status: 0, message: error.message } };
  }
};

const deleteClientTaxStrategy = async (strategyId) => {
  try {
    const data = await API.delete(
      `client/deleteClientTaxStrategy/${strategyId}`,
    );
    return data;
  } catch (error) {
    console.log(error);
    return error?.response || { data: { status: 0, message: error.message } };
  }
};

/**
 * AI assist — processed on backend via OpenAI ChatGPT API.
 * mode: "improve" | "generate"
 */
const generateTaxStrategyAI = async ({
  client_id,
  mode,
  draft = "",
  prompt = "",
  category,
}) => {
  try {
    const { data } = await API.post(`client/generateTaxStrategyAI`, {
      client_id,
      mode,
      draft,
      prompt,
      ...(category ? { category: normalizeClientDetailCategory(category) } : {}),
    });
    return data;
  } catch (error) {
    console.log(error);
    return (
      error?.response?.data || {
        status: 0,
        message: error.message || "AI request failed",
      }
    );
  }
};

const getTaxStrategyComments = async (taxStrategyId) => {
  try {
    const { data } = await API.get(
      `client/getTaxStrategyComments/${taxStrategyId}`,
    );
    return data?.data || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

const createTaxStrategyComment = async ({ tax_strategy_id, comment }) => {
  try {
    const data = await API.post(`client/createTaxStrategyComment`, {
      tax_strategy_id,
      comment,
    });
    return data;
  } catch (error) {
    console.log(error);
    return error?.response || { data: { status: 0, message: error.message } };
  }
};

export {
  getClientTaxStrategies,
  createClientTaxStrategy,
  updateClientTaxStrategy,
  saveClientTaxStrategy,
  sendClientTaxStrategy,
  deleteClientTaxStrategy,
  generateTaxStrategyAI,
  getTaxStrategyComments,
  createTaxStrategyComment,
};
